import { SignalAIRankReport } from "@/components/rank-tracker/SignalAIRankReport";
import type { RankTrackerReport } from "@/types";

interface PublicRankTrackerViewProps {
  payload: RankTrackerReport;
}

export function PublicRankTrackerView({ payload }: PublicRankTrackerViewProps) {
  return <SignalAIRankReport publicData={payload} />;
}
